var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-message-wrap" },
    [
      _c("entry-message-attachment-files", {
        attrs: { "summary-files": _vm.summaryFiles, "entry-id": _vm.entryId },
        on: { fetchAllMessage: _vm.fetchAllMessage },
      }),
      _vm._v(" "),
      _vm.messageReservationReserved
        ? _c("entry-message-reservation-reserved-to-applicant", {
            attrs: {
              "message-reservation": _vm.messageReservationReserved,
              "entry-id": _vm.entryId,
            },
            on: {
              setMessage: _vm.setMessage,
              fetchAllMessage: _vm.fetchAllMessage,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.messageReservationCanceled
        ? _c("entry-message-reservation-canceled-to-applicant", {
            attrs: {
              "message-reservation": _vm.messageReservationCanceled,
              "entry-id": _vm.entryId,
              "is-withdraw": _vm.isWithdraw,
            },
            on: {
              setMessage: _vm.setMessage,
              fetchAllMessage: _vm.fetchAllMessage,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.renderingAllMessage, function (message, i) {
        return [
          message.key === _vm.historyFromKey
            ? [
                _c("entry-message-history-from-applicant", {
                  key: i,
                  attrs: {
                    body: message.body,
                    subject: message.subject,
                    date: message.date,
                    "is-reserved": _vm.messageReservationReserved !== null,
                    "is-withdraw": _vm.isWithdraw,
                  },
                  on: { setMessage: _vm.setMessage },
                }),
              ]
            : message.key === _vm.historyToKey
            ? [
                _c("entry-message-history-to-applicant", {
                  key: i,
                  attrs: {
                    body: message.body,
                    subject: message.subject,
                    date: message.date,
                    "is-read": message.isRead,
                    files: message.files,
                    "interview-adjustment": message.interviewAdjustment,
                    "is-remind-mail": message.isRemindMail,
                  },
                }),
              ]
            : message.key === _vm.historyEntryKey
            ? [
                _c("entry-message-history-entry", {
                  key: i,
                  attrs: {
                    date: message.date,
                    "first-name": message.firstName,
                    "last-name": message.lastName,
                    job: message.job,
                    "special-favors": message.specialFavors,
                  },
                }),
              ]
            : message.key === _vm.historyPhaseKey
            ? [
                _c("entry-message-history-phase", {
                  key: i,
                  attrs: {
                    date: message.date,
                    "phase-name": message.phaseName,
                  },
                }),
              ]
            : message.key === _vm.historyStatusKey
            ? [
                _c("entry-message-history-status", {
                  key: i,
                  attrs: {
                    date: message.date,
                    "status-name": message.statusName,
                  },
                }),
              ]
            : message.key === _vm.historyScoutKey
            ? [
                _c("entry-message-history-scout", {
                  key: i,
                  attrs: {
                    body: message.body,
                    subject: message.subject,
                    date: message.date,
                    job: message.job,
                    "expiration-date": message.expirationDate,
                    "special-favors": message.specialFavors,
                  },
                }),
              ]
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm.hasScoutMessageSecondAndOver && !_vm.isShowAllMessage
        ? _c("div", { staticClass: "boss-more-button" }, [
            _c(
              "a",
              {
                staticClass: "boss-button",
                attrs: { href: "javascript:void(0)", "data-test": "read-more" },
                on: { click: _vm.onShowAllMessage },
              },
              [
                _c("span", { staticClass: "boss-more-button-text" }, [
                  _vm._v("もっと見る"),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }